module.exports = __webpack_public_path__ + "static/img/header.c14f0dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/header.png
// module id = 832
// module chunks = 1